import { ICurrency } from './Types';

export function appendCurrencyInfo(
    currency: ICurrency,
    input: number,
    format: boolean = false
): string {
    return input == null
        ? ''
        : currency == null
        ? `${format ? input.toLocaleString() : input.toString()}`
        : `${currency.prefix}${
              format ? input.toLocaleString().replace('−', '-') : input.toString().replace('−', '-')
          }${currency.suffix}`;
}

export function addPlusSign(value: string): string {
    return !value ? '' : value.charAt(0) !== '-' ? '+' + value : value;
}

export function removeMinusSign(value: string): string {
    return !value ? '' : value.charAt(0) === '-' ? value.slice(1) : value;
}
